module.exports = __webpack_public_path__ + "static/media/ocean_logo_white2.bc306345.png";